export default __webpack_public_path__ + "static/media/about-bg.b76bdeab.png";